<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 739 319">
    <g  transform="translate(-232 -462)">
      <g transform="translate(232 462)" fill="#fcfcfc" stroke="#bbf1b7" stroke-width="8">
        <rect width="669" height="319" rx="58" stroke="none"/>
        <rect x="4" y="4" width="661" height="311" rx="54" fill="none"/>
      </g>
      <path d="M0,0H0A39,39,0,0,1,39,39V78A39,39,0,0,1,0,117H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z" transform="translate(910 563)" fill="#bbf1b7"/>
      <rect ref="battery" width="610" height="257" rx="39" transform="translate(262 493)" fill="#7dd477" />
    </g>
  </svg>
</template>
<script>
import { Tweenable } from 'shifty'

export default {
  name: 'Battery',
  props: ['percent', 'index'], // 0 - 1  float number
  data () {
    return {
      width: 0,
      isAnimated: false
    }
  },
  computed: {
    batterColor () {
      const percent = this.percent * 10
      switch (true) {
        case percent > 5:
          return '#7dd477'
        case percent >= 4 && percent <= 5:
          return '#AEEA00'
        case percent >= 3 && percent < 4:
          return '#F9A825'
        case percent >= 2  && percent < 3:
          return '#FF6D00'
        case percent < 2:
          return '#DD2C00'  
        default:
          return '#7dd477'
      }
    },
    batteryWidth () {
      return this.percent ? 610 * this.percent : 0
    }
  },
  methods: {
    initAnimate () {
      if( this.isAnimated ) return
      const battery = this.$refs.battery
      const tweenable = new Tweenable()
      tweenable.tween({
        from:{ width: 610, color: '#7dd477' },
        to: { width: this.batteryWidth, color: this.batterColor },
        duration: 2000,
        easing: 'easeOutCubic',
        step: state => {
          battery.setAttribute('width', state.width)
          battery.setAttribute('fill', state.color)
        },
        start: () => {
          this.isAnimated = true
        }
      })
    },
  }
}
</script>
